const namespace = 'DomainResolver';

export const REQUEST_APP_SETTINGS = `${namespace}/REQUEST_APP_SETTINGS`;
export const RECEIVE_APP_SETTINGS_SUCCESS = `${namespace}/RECEIVE_APP_SETTINGS_SUCCESS`;
export const RECEIVE_APP_SETTINGS_ERROR = `${namespace}/RECEIVE_APP_SETTINGS_ERROR`;
